import type { ApplyProductModificationApi } from 'epic/postTradeOperations/productModification/applyProductModificationEpic';
import type { FetchProductModificationApi } from 'epic/postTradeOperations/productModification/fetchProductModificationFormEpic';
import type {
  ProductModificationAck,
  ProductModificationFormResult,
  ProductModificationRequest,
} from 'models/forms/productModification';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http.old/httpClient.model';

export type ProductModificationApi = FetchProductModificationApi & ApplyProductModificationApi;

export function productModificationApi(http$: IHttpClient): ProductModificationApi {
  return {
    fetchFormValues(tabId: string, productId: string): Observable<ProductModificationFormResult> {
      return http$
        .getJSON<ProductModificationFormResult>({
          url: `api/v1/product-modification-form/${tabId}/default/${productId}`,
        })
        .pipe(map(({ payload }) => payload));
    },
    apply(productModificationRequest: ProductModificationRequest): Observable<ProductModificationAck> {
      return http$
        .post<ProductModificationAck>({
          url: 'api/v1/product-modification-form/apply',
          body: productModificationRequest,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
